/**
 * Subdomain prefix sent as X-SUBDOMAIN (see subdomain-link). Empty on apex hosts
 * like example.com; non-empty on tenant hosts like org.example.com.
 */
export function getAuthHostnameSubdomainPrefix(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  return (
    process.env.NODE_ENV === 'production'
      ? window.location.hostname.split('.').slice(0, -2).join('.')
      : process.env.REACT_APP_SUBDOMAIN ??
        window.location.hostname.split('.').slice(0, -2).join('.') ??
        'test'
  ).trim();
}

/** True on marketing / apex hosts (no tenant subdomain prefix). */
export function isLoginRootDomainHost(): boolean {
  return getAuthHostnameSubdomainPrefix() === '';
}

/**
 * `rootDomain=1` is for links from the apex site; on tenant subdomains it must be
 * ignored so login and related flows use the normal tenant API.
 */
export function shouldUseRootDomainAuthFlow(searchParams: {
  get: (key: string) => string | null;
}): boolean {
  return searchParams.get('rootDomain') === '1' && isLoginRootDomainHost();
}
